import styled from 'styled-components';
import { colors } from '../../config/styles';
import { theme } from '../../styles/theme';

export type ChipLabelVariant =
  | 'blue'
  | 'purple'
  | 'white'
  | 'grey'
  | 'dark-blue';

const chipLabelVariantLookup: Record<
  ChipLabelVariant,
  { backgroundColor: string; color: string }
> = {
  blue: {
    backgroundColor: theme.colors.blue500,
    color: theme.colors.secondary900,
  },
  purple: {
    backgroundColor: '#efe7fd',
    color: colors.purple,
  },
  white: {
    backgroundColor: '#fff',
    color: theme.colors.mainBlue,
  },
  grey: {
    backgroundColor: '#e8eaf2',
    color: '#222',
  },
  'dark-blue': {
    backgroundColor: theme.colors.mainBlue,
    color: '#fff',
  },
};

const Container = styled.div<{ $variant?: ChipLabelVariant }>`
  border-radius: 4px;
  font-weight: 500;
  ${({ $variant = 'blue' }) => $variant && chipLabelVariantLookup[$variant]}
`;

export const FormulaLabel = styled(Container)`
  position: relative;
  padding: 2px 12px 2px 4px;
  font-size: 12px;
  line-height: 18px;
  word-break: break-all;
`;
